// extracted by mini-css-extract-plugin
export default {"Loader":"styles_Loader__eMhbS","loader-animation":"styles_loader-animation__CdtQh"};